module.exports = __webpack_public_path__ + "static/img/xingFull.11afcce4.svg";